import { createApiRef, DiscoveryApi, IdentityApi } from '@backstage/core-plugin-api';

export interface PackagesApi {
  refreshPackages(packageName?: string): Promise<{ status: string }>;
}

export const packagesApiRef = createApiRef<PackagesApi>({
  id: 'plugin.packages.api',
});

export class PackagesApiClient implements PackagesApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly identityApi: IdentityApi;

  constructor(options: { discoveryApi: DiscoveryApi; identityApi: IdentityApi }) {
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }

  async refreshPackages(packageName?: string): Promise<{ status: string }> {
    const baseUrl = await this.discoveryApi.getBaseUrl('catalog');
    const { token } = await this.identityApi.getCredentials();

    const response = await fetch(`${baseUrl}/provider/packages/refresh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      body: JSON.stringify({ packageName }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
      throw new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }
}